module.exports = __webpack_public_path__ + "static/img/01bg@2x.1f8c8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/01bg@2x.png
// module id = Jx4d
// module chunks = 1